<template>
    <CardPage :section="12" :page="10" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Well, we have made it to the end of a session together in the House of LS. You’ve made your Mother very proud! You’ve earned another trophy to add
            to your collection! Today’s trophy represents all of the knowledge and ideas you’ve learned along the way.
        </p>
        <ResponsiveImage :src="trophy.image" :alt="trophy.text" flex="xs6"></ResponsiveImage>
        <p>
            Remember:<br />
            Educating myself: I deserve it! I can have it! And I know how to get it!
        </p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        trophy: get('section12/trophy')
    },
    methods: {
        finish() {
            this.$store.set('section12/complete', true);
            this.$store.set('section12/trophy@earned', true);
        }
    }
};
</script>
